import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Grid, Typography } from '@mui/material';
import Breadcrumb from '../../component/Breadcrumb';
import PageTabing from '../../component/PageTabing';
import SearchBox from '../../component/SearchBox';
import EventsTable from './EventsTable';
import { fetchEventSheetData } from '../../api/mappingApi';
import Loader from '../../component/Loader/Loader';

const Events = () => {
  const [page, setPage]                         = React.useState(0);
  const [showLoader, setShowLoader]             = React.useState(false);
  const [searchValue, setSearchValue]           = React.useState('');
  const [rowsPerPage, setRowsPerPage]           = React.useState(100);
  const [eventMappingData, setEventMappingData] = React.useState([]);
 

  const handleChangeTextValue = (event) => {
    setSearchValue(event.target.value);
  }

  React.useEffect(() => {
    fetchData(page,rowsPerPage,searchValue);
  },[page,rowsPerPage]);

  const fetchData = async (page,rowsPerPage,searchValue) => {
    setShowLoader(true);
    const data = await fetchEventSheetData(page,rowsPerPage,searchValue);
    setShowLoader(false);
    setEventMappingData(data);
  }

  const handleSearch = async () => {
    if(searchValue !== ''){
      if(page > 0){
        setPage(0); 
      } else {
        fetchData(page,rowsPerPage,searchValue);
      }
    }
  }

  const handleClearSearch = () => {
    setSearchValue('');
    fetchData(page,rowsPerPage,'');
  }


  const handleChangePage = (event, pageVal) => {
    setPage(pageVal);
  }

  const handleChangeRowsPerPage = (event) => {
    const value = event.target.value === 'ALL' ? -1 : parseInt(event.target.value,10)
    setRowsPerPage(value);
    setPage(0);
  }

  return (
    <>
      {showLoader && 
        <Loader />
      }
      <Breadcrumb title="Events">
        <Typography component={Link} to="/" variant="subtitle2" color="primary" className="link-breadcrumb">
          Dashboard
        </Typography>
        <Typography variant="subtitle2" color="inherit" className="link-breadcrumb">
        Events
        </Typography>
      </Breadcrumb>
      <PageTabing value="event" />
      <Box component="section">
        <Grid className="contentBox">
          <Grid sx={{ mb:3 }} container direction="row">
            <Grid item xs={12} sm={12} md={6}>
              <SearchBox 
                label="English Text"
                value={searchValue}
                handleChangeTextValue = {handleChangeTextValue}
                handleSearch={handleSearch}
                handleClearSearch={handleClearSearch}
              />
              
            </Grid>
          </Grid>
          <EventsTable 
              page             = {page} 
              rowsPerPage      = {rowsPerPage}
              mappingData      = {eventMappingData}
              handleChangePage = {handleChangePage}
              handleChangeRowsPerPage = {handleChangeRowsPerPage}
          />
        </Grid>
      </Box>
    </>
  );
};

export default Events;
